export const imports = {
  form: {
    clickOrDrag: 'ここにCSVファイルをドロップしてアップロード',
  },
  pageHeader: {
    title: '洗濯機データをCSVでインポート',
    download: 'CSV サンプルのダウンロード',
    importOverWrite: 'インポート（上書き）',
    importInsert: 'インポート（追加）',
  },
}
